import React, { Component } from 'react'
import { connect } from 'react-redux'

// actions
import { setEmbeddedBookingOtherInfo } from '../../../actions/embeddedbooking'

// Elements
import Button from '../../../shared/elements/button'
import Radio from '../../../shared/elements/radio'
import DropDown from '../../../shared/elements/dropDown'
import Text from '../../../shared/elements/text'
import Check from '../../../shared/elements/check'

// utils
import { translation } from '../../../utils/helpers'
import moment from 'moment'

// Icons
import { EmbeddedBookingIcons } from '../../../shared/elements/icons'
import Icon from '../../../shared/elements/icon'

// Styles
import './otherinfoview.scss'
import DateTime from '../../../shared/elements/datetime'
import LabelWrapper from '../../../shared/elements/labelWrapper'

class OtherInfoView extends Component {
  constructor (props) {
    super(props)
    this.state = {
      OtherInfo: {
        DamageNr: '',
        InsuranceCompanyId: 0,
        NeedRental: false,
        CarRentalId: 0,
        DamageDate: null
      }
    }
    this.onChange = this.onChange.bind(this)
    this.onDateChange = this.onDateChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onBlurDamageDate = this.onBlurDamageDate.bind(this)
    this.checkAndNav = this.checkAndNav.bind(this)
    this.renderRentals = this.renderRentals.bind(this)
  }

  componentDidMount () {
    this.setState({
      OtherInfo: this.props.OtherInfo
    })
  }

  onChange (e) {
    e.persist()

    let value = e.target.value
    let names = e.target.name.split('.')
    if (names[1] === 'InsuranceCompanyId' || names[1] === 'CarRentalAlternativeId') value = parseInt(e.target.value)
    if (e.target.type === 'checkbox') value = e.target.checked
    this.setState({
      OtherInfo: {
        ...this.state.OtherInfo,
        [names[1]]: value
      }
    }, () => {
      if (e.target.type === 'checkbox' || e.target.type === 'radio' || e.target.type === 'select-one') {
        this.props.setEmbeddedBookingOtherInfo(this.state.OtherInfo)
        this.props.onBlur(e)
      }
    })
  }

  onDateChange (date) {
    this.setState({
      OtherInfo: {
        ...this.state.OtherInfo,
        DamageDate: date
      }
    }, () => {
      this.props.setEmbeddedBookingOtherInfo(this.state.OtherInfo)
    })
  }

  onBlur (e) {
    e.persist()
    this.props.setEmbeddedBookingOtherInfo(this.state.OtherInfo)
    this.props.onBlur(e)
  }

  onBlurDamageDate (e) {
    this.props.onBlur(e, true)
  }

  checkAndNav (e, opt) {
    e.persist()
    this.props.onNavClick(e, opt)
  }

  renderRentals () {
    let { OtherInfo } = this.state
    let CarRentalAlternatives = this.props.CarRentalAlternatives
    let showAlts = this.props.OfferCarRentalAlts && CarRentalAlternatives.length !== 0

    const renderCarRentalAlts = (val, key) => {
      return (
        <Radio key={key} name={'OtherInfo.CarRentalAlternativeId.' + key} value={val.Id} checked={OtherInfo.CarRentalAlternativeId === val.Id} onChange={this.onChange} labelText={val.Name} />
      )
    }
    return (
      showAlts && <div className='carrental--inner'>
        <Radio name='OtherInfo.CarRentalAlternativeId' value={0} checked={!OtherInfo.CarRentalAlternativeId} onChange={this.onChange} labelText={translation(629)} />
        <LabelWrapper labelText={18363}>
          {CarRentalAlternatives.map(renderCarRentalAlts)}
        </LabelWrapper>
      </div>
    )
  }

  render () {
    let { OtherInfo } = this.state
    let damageDate = OtherInfo.DamageDate
    let inputProps = {
      placeholder: translation(18322)
    }
    let leftChildren = true

    if (typeof damageDate === 'string') {
      damageDate = moment(damageDate.substring(0, 10))
    }
    return (
      <div className='other-info__view'>
        <article className='main'>
          {this.props.children}
          <h1>{translation(16687)}</h1>
          <DropDown name='OtherInfo.InsuranceCompanyId' value={OtherInfo.InsuranceCompanyId} onChange={this.onChange} helpText={translation(16850)}>
            <option value='0'>{translation(14863)}</option>
            {this.props.InsuranceCompanies.map((val, index) => {
              if (val.Active) {
                if (val.InsuranceCompanyId === OtherInfo.InsuranceCompanyId) {
                  return (
                    <option value={val.InsuranceCompanyId} key={index} selected>{val.Company}</option>
                  )
                } else {
                  return (
                    <option value={val.InsuranceCompanyId} key={index}>{val.Company}</option>
                  )
                }
              }
            })}
          </DropDown>
          <Text name='OtherInfo.DamageNr' value={OtherInfo.DamageNr || ''} onChange={this.onChange} placeholder={translation(16701)} helpText={translation(16851)} onBlur={this.onBlur} />
          <DateTime name='OtherInfo.DamageDate' timeFormat={false} value={damageDate} onChange={this.onDateChange} onBlur={this.onBlurDamageDate} inputProps={inputProps} closeOnSelect />
          <Check name='OtherInfo.NeedRental' checked={OtherInfo.NeedRental} onChange={this.onChange} labelText={translation(18437)} />
          {OtherInfo.NeedRental && this.renderRentals()}
          <div className='ctaWrapper'>
            <Button style='secondary' labelText={translation('394')} onClick={(e) => this.props.onNavClick(e, 'previous')} leftChildren={leftChildren}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Left_Arrow}
                injectSvg
              />
            </Button>
            <Button labelText={translation(237)} onClick={(e) => this.checkAndNav(e, 'next')}>
              <Icon
                size='s'
                icon={EmbeddedBookingIcons.Right_Arrow}
                injectSvg
              />
            </Button>
          </div>
        </article>
        <aside className='side'>
          <section>
            <h1>{translation(18432)}</h1>
            <p>{translation(16692)}</p>
          </section>
        </aside>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    brands: state.common.brands,
    InsuranceCompanies: state.embeddedbooking.InsuranceCompanies,
    CarRentalAlternatives: state.embeddedbooking.CarRentalAlternatives,
    OfferCarRentalAlts: state.embeddedbooking.OfferCarRentalAlts,
    OtherInfo: state.embeddedbooking.OtherInfo
  }
}

export default connect(mapStateToProps, { setEmbeddedBookingOtherInfo })(OtherInfoView)



// WEBPACK FOOTER //
// ./src/app/pages/EmbeddedBooking/OtherInfoView/index.js